import React from "react";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

/**
 * MicroMotion utilities
 * WHAT: Small helper that centralizes reduced-motion checks and provides a wrapper
 * component to conditionally apply motion-related classes.
 * WHY: Task 075 requires respecting prefers-reduced-motion and centralizing micro-motions.
 * HOW: Exposes `usePrefersReducedMotion` hook and `MicroMotion` wrapper component.
 */

interface MicroMotionProps {
  /** Children rendered inside wrapper */
  children: React.ReactNode;
  /** CSS class to apply when motion is allowed */
  motionClassName?: string;
  /** CSS class to apply when motion is reduced */
  reducedMotionClassName?: string;
}

export function MicroMotion({ children, motionClassName = "", reducedMotionClassName = "" }: MicroMotionProps) {
  const reduced = usePrefersReducedMotion();
  const className = reduced ? reducedMotionClassName : motionClassName;
  return <span className={className}>{children}</span>;
}

/**
 * Note: This is intentionally minimal. The design system should expand this with
 * animation tokens and a centralized CSS approach (Tailwind classes or CSS modules).
 */
